<template>
    <b-form-group>
        <template slot="label">
            <div class="label">
                {{ $t('nBox.form.nBoxTitle') }}
            </div>
        </template>
        <b-form-input
            size="sm"
            :state="state"
            :value="value"
            aria-describedby="input"
            @input="$emit('update:value', $event)"
        />
        <b-form-invalid-feedback id="input">
            {{ $t('form.validations.answerRequired') }}
        </b-form-invalid-feedback>
    </b-form-group>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            default: null,
        },
        state: {
            type: Boolean,
            default: null,
        },
    },
}
</script>
